import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpService } from '../core/http.service';
import { SiteService } from './site.service';
import { Message } from '../models/message';



const OAUTH_URL = environment.oauthUrl;
const TOKEN_STORE = environment.tokenStore;

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    private store: any;
    private isRememberMe: boolean = false;

    constructor(
        private router: Router,
        private http: HttpClient,
        private httpService: HttpService,
        private siteService: SiteService
    ) {
        if (this.getRememberMe()) {
            this.store = localStorage;
        } else {
            this.store = sessionStorage;
        }

    }


    public getStore(): any {
        return this.store;
    }

    /**
     * 자동로그인 여부
     * @param arg 
     */
    public setRememberMe(arg: boolean): void {

        this.isRememberMe = arg;
        localStorage.setItem("rememberMe", arg ? "1" : "0");
        if (arg) {
            this.store = localStorage;
        } else {
            this.store = sessionStorage;
        }

    }

    public getRememberMe(): boolean {
        let arg = localStorage.getItem("rememberMe");
        this.isRememberMe = (!arg || arg == "0") ? false : true;
        return this.isRememberMe;
    }



    public signIn(username: string, password: string) {
        console.log(username, password)
        return this.oauth('/token', { username: username, password: password }).pipe(
            map(token => {
                this.saveToken(token);
                return token;
            })
        );
    }

    public signOut(updatePwd?: boolean) {
        console.log(updatePwd)
        this.httpService.delete('/oauth/revoke').subscribe(res => {
            console.log(updatePwd)
            this.removeToken();
            this.siteService.sendMessage(new Message("logout"));
            if (updatePwd) {
                console.log(updatePwd)
                this.router.navigate(["/sign/sign-in"]);
            } else {
                this.router.navigate(["/"]);
            }
        })
    }

    public oauth(url: string, user: any) {

        let clientId = this.isRememberMe ? "appclient" : "webclient";

        let params = new URLSearchParams();
        console.log(OAUTH_URL + url, user.username, user.password)
        params.append('username', user.username);
        params.append('password', user.password);
        params.append('grant_type', 'password');
        params.append('client_id', clientId);
        var headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8', 'Authorization': 'Basic ' + btoa(`${clientId}:apppassword`) });
        return this.http.post<any>(OAUTH_URL + url, params.toString(), { headers: headers });
    }


    public refreshToken(): Observable<any> {

        let clientId = this.isRememberMe ? "appclient" : "webclient";

        let token = this.getToken();
        let params = new URLSearchParams();
        params.append('grant_type', 'refresh_token');
        params.append('refresh_token', token.refresh_token);

        console.log('refreshToken', params.toString());
        var headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8', 'Authorization': 'Basic ' + btoa(`${clientId}:apppassword`) });
        return this.http.post<any>(OAUTH_URL + '/token', params.toString(), { headers: headers });
    }


    public saveToken(token) {
        console.log(JSON.stringify(token))
        this.store.setItem('token', JSON.stringify(token));
    }

    public removeToken() {
        this.store.removeItem('token');
    }

    public getToken() {
        if (this.store.getItem('token')) {
            return JSON.parse(this.store.getItem('token'));
        } else {
            return "";
        }
    }

    public isLogin(): boolean {
        if (this.store.getItem('token')) {
            return true;
        } else {
            return false;
        }
    }

    public getUsername() {
        if (this.store.getItem('token')) {
            return JSON.parse(this.store.getItem('token')).username;
        } else {
            return "";
        }
    }

    public getSocialLoginUrl(provider: string) {

        let using = this.getUsing();
        let url: string = `/socials/login/${provider}/${using}`;
        return this.httpService.get(url);

    }

    // serverside 에서 model 로 값을 내려주고 ftl 파일에서 set 한다.
    public getUsing(): string {
        let using = localStorage.getItem("using");
        if (!using)
            using = "browser";   // browser or app

        return using;
    }
}
